// Replace with swagger when ready
import { DocumentPrintResponse, ModbusAccessPointRequest, ModbusAccessPointResponse, PrintDocumentRequest, PrinterStatus } from '@absg/nim-client-shared';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModbusService {
  basePath = 'http://localhost:5970'; // 44303 - local testing
  private defaultHeaders = new HttpHeaders();
  isSimulateModeOn = false;

  constructor(
    protected httpClient: HttpClient,
  ) { }

  checkPrinterStatus(body?: string[]): Observable<PrinterStatus[]> {
    const headers = this.getHeaders();
    return this.httpClient.request<PrinterStatus[]>('post', `${this.basePath}/api/printer/checkStatus`,
      { body, headers },
    );
  }
  sendPrintRequest(body?: PrintDocumentRequest): Observable<DocumentPrintResponse> {
    const headers = this.getHeaders();
    return this.httpClient.request<DocumentPrintResponse>('post', `${this.basePath}/api/printer/print`,
      { body, headers },
    );
  }
  sendPrintLength(printerName: string, size: number): Observable<boolean> {
    const headers = this.getHeaders();
    return this.httpClient.request<boolean>('post', `${this.basePath}/api/printer/setLength/${printerName}/${size}`,
      { headers },
    );
  }

  cancelUnlockAccessPointPost(body?: ModbusAccessPointRequest): Observable<ModbusAccessPointResponse> {
    const headers = this.getHeaders();
    return this.httpClient.request<ModbusAccessPointResponse>('post', `${this.basePath}/api/modbus/CancelUnlockAccessPoint`,
      { body, headers },
    );
  }

  checkAnyOpenDoorsGet(): Observable<number[]> {
    const headers = this.getHeaders();
    return this.httpClient.request<Array<number>>('get', `${this.basePath}/api/modbus/CheckAnyOpenDoors`,
      { headers },
    );
  }

  executeCloseCallsPost(body?: ModbusAccessPointRequest): Observable<ModbusAccessPointResponse> {
    const headers = this.getHeaders();
    return this.httpClient.request<ModbusAccessPointResponse>('post', `${this.basePath}/api/modbus/ExecuteCloseCalls`,
      { body, headers },
    );
  }

  failAllOpenAccessPointsPost(body?: ModbusAccessPointRequest): Observable<ModbusAccessPointResponse> {
    const headers = this.getHeaders();
    return this.httpClient.request<ModbusAccessPointResponse>('post', `${this.basePath}/api/modbus/FailAllOpenAccessPoints`,
      { body, headers },
    );
  }

  getAllFailedDoorsGet(body?: ModbusAccessPointRequest): Observable<Array<number>> {
    const headers = this.getHeaders();
    return this.httpClient.request<Array<number>>('get', `${this.basePath}/api/modbus/GetAllFailedDoors`,
      { body, headers },
    );
  }

  lockAccessPointPost(body?: ModbusAccessPointRequest): Observable<ModbusAccessPointResponse> {
    const headers = this.getHeaders();
    return this.httpClient.request<ModbusAccessPointResponse>('post', `${this.basePath}/api/modbus/LockAccessPoint`,
      { body, headers },
    );
  }

  lockAllAccessPointsPost(body?: ModbusAccessPointRequest): Observable<ModbusAccessPointResponse> {
    const headers = this.getHeaders();
    return this.httpClient.request<ModbusAccessPointResponse>('post', `${this.basePath}/api/modbus/LockAllAccessPoints`,
      { body, headers },
    );
  }

  resetAccessPointPost(body?: ModbusAccessPointRequest): Observable<ModbusAccessPointResponse> {
    const headers = this.getHeaders();
    return this.httpClient.request<ModbusAccessPointResponse>('post', `${this.basePath}/api/modbus/ResetAccessPoint`,
      { body, headers },
    );
  }

  resetAllAccessPointsPost(body?: ModbusAccessPointRequest): Observable<ModbusAccessPointResponse> {
    const headers = this.getHeaders();
    return this.httpClient.request<ModbusAccessPointResponse>('post', `${this.basePath}/api/modbus/ResetAllAccessPoints`,
      { body, headers },
    );
  }

  unlockAccessPointPost(body?: ModbusAccessPointRequest): Observable<ModbusAccessPointResponse> {
    const headers = this.getHeaders();
    return this.httpClient.request<ModbusAccessPointResponse>('post', `${this.basePath}/api/modbus/UnlockAccessPoint`,
      { body, headers },
    );
  }

  refreshStationConfigurationPost(body?: ModbusAccessPointRequest): Observable<ModbusAccessPointResponse> {
    const headers = this.getHeaders();
    return this.httpClient.request<ModbusAccessPointResponse>('post', `${this.basePath}/api/modbus/RefreshStationConfiguration`,
      { body, headers },
    );
  }

  private getHeaders(): HttpHeaders {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);
    headers = headers.set('nc-station-api-key', 'A270DC02FBA547D4BE4CE9A1722CFF68');
    return headers;
  }
}
